import React from 'react';
import { Container, IconWrapper, Title, Description, RetryButton } from './ErrorMessage.styled';

export interface ErrorMessageProps {
  /** エラータイトル */
  title?: string;
  /** エラー詳細メッセージ */
  description?: string;
  /** フルページ表示（min-height: 100vh） */
  fullPage?: boolean;
  /** リトライボタンのコールバック（指定時のみボタン表示） */
  onRetry?: () => void;
  /** リトライボタンのラベル */
  retryLabel?: string;
}

/**
 * エラーメッセージコンポーネント
 * アプリ全体で統一されたエラー表示を提供
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title = 'データの取得に失敗しました',
  description = 'ネットワーク接続を確認してください',
  fullPage = false,
  onRetry,
  retryLabel = '再試行',
}) => {
  return (
    <Container $fullPage={fullPage}>
      <IconWrapper>⚠️</IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
      {onRetry && (
        <RetryButton onClick={onRetry}>
          {retryLabel}
        </RetryButton>
      )}
    </Container>
  );
};

export default ErrorMessage;
